import { useState } from "react";
import { Box, Collapse, Link, Typography, useTheme } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  INHERITANCE_REUSE_DISCLAIMER_DETAILS,
  INHERITANCE_REUSE_DISCLAIMER_SUMMARY,
} from "@/features/inheritanceReuse/utils/constants";

/**
 * 推定値の精度に関するディスクレーマ（注意書き）。
 * 水色帯の Alert は浮くため、控えめなキャプション（情報アイコン＋グレー文字）にとどめ、
 * 詳細は「詳しく」で開閉（初期は閉じる）。一覧の直前に置き、存在感を抑えつつ必ず目に入るようにする。
 */
export const InheritanceReuseDisclaimer: React.FC = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const gray = theme.palette.darkgray?.main ?? "#777777";

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.75 }}>
        <InfoOutlinedIcon sx={{ fontSize: 16, color: gray, mt: "1px" }} />
        <Typography
          variant="caption"
          sx={{ color: gray, lineHeight: 1.6, flex: 1 }}
        >
          {INHERITANCE_REUSE_DISCLAIMER_SUMMARY}{" "}
          <Link
            component="button"
            type="button"
            underline="hover"
            onClick={() => {
              setOpen((prev) => !prev);
            }}
            sx={{
              fontSize: "inherit",
              fontWeight: 600,
              color: theme.palette.primary.main,
              verticalAlign: "baseline",
            }}
          >
            {open ? "閉じる" : "詳しく"}
          </Link>
        </Typography>
      </Box>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box component="ul" sx={{ pl: 3, mt: 0.5, mb: 0 }}>
          {INHERITANCE_REUSE_DISCLAIMER_DETAILS.map((text, index) => (
            <Typography
              key={index}
              component="li"
              variant="caption"
              sx={{ display: "list-item", color: gray, lineHeight: 1.7 }}
            >
              {text}
            </Typography>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
};
